// API Endpoints
export const API_ENDPOINTS = {
  // Content endpoints (matches Django API)
  CONTENT: "/api/content",
  CONTENT_BY_ID: (id: string) => `/api/content/${id}`,
  CONTENT_VERSIONS: (id: string) => `/api/content/${id}/versions`,
  CONTENT_VERSION: (id: string, version: number) =>
    `/api/content/${id}/versions/${version}`,

  // Projects endpoints
  PROJECTS: "/api/content/projects",
  PROJECT_BY_ID: (id: string) => `/api/content/projects/${id}`,

  // TODO: Remove actor endpoints - using Supabase users directly
  // ACTORS: '/api/actors',
  // ACTOR_BY_ID: (id: string) => `/api/actors/${id}`,
  // ACTOR_BY_SUPABASE_ID: (supabaseId: string) => `/api/actors/supabase/${supabaseId}`,
  // AI_AGENTS: '/api/actors/ai-agents',
  // SYNC_ACTOR: '/api/actors/sync-from-supabase',

  // Content Generation endpoints
  BLOG_OUTLINE: "/api/content-generation/blog/outline",
  BLOG_OUTLINE_STREAM: (outlineId: string) =>
    `/api/content-generation/blog/outline/stream/${outlineId}`,
  BLOG_WRITING_INSTRUCTIONS:
    "/api/content-generation/blog/writing-instructions",
  BLOG_SECTIONS: "/api/content-generation/blog/generate-sections",
  BLOG_CREATE: "/api/content-generation/blog/create-blog",
  BLOG_REVIEW: "/api/content-generation/blog/review",
  STREAM_CONTINUE: "/api/content-generation/stream-continue",
  BLOG_STATE: (documentId: string) =>
    `/api/content-generation/blog/state/${documentId}`,
  BLOG_STATE_RESET: (documentId: string) =>
    `/api/content-generation/blog/state/${documentId}/reset`,
  WHOAMI: "/api/content-generation/whoami",
  WORKFLOW_STREAM: (documentId: string) =>
    `/api/content-generation/workflow/stream/${documentId}`,
  WORKFLOW_STATE: (documentId: string) =>
    `/api/content-generation/workflow/state/${documentId}`,

  // Evaluations endpoints
  METRIC_DEFINITIONS: "/api/evals/metric-definitions",
  METRIC_DEFINITION_BY_ID: (id: string) =>
    `/api/evals/metric-definitions/${id}`,
  QUALITY_METRICS: "/api/evals/quality-metrics",
  QUALITY_EVALUATIONS: "/api/evals/quality-evaluations",
  PERFORMANCE_METRICS: "/api/evals/performance-metrics",
  PERFORMANCE_MEASUREMENTS: "/api/evals/performance-measurements",
  BLOG_EVALUATE: "/api/evals/blog/evaluate",

  // Stripe endpoints
  CREATE_PORTAL_SESSION: "/api/billing/create-portal-session",
  CREATE_CHECKOUT_SESSION: "/api/billing/create-checkout-session",
  GET_SUBSCRIPTION_STATUS: "/api/billing/subscription-status",

  // Integrations
  WEBFLOW_AUTH: "/api/integrations/webflow/auth",
  WEBFLOW_STATUS: "/api/integrations/webflow/status",
  WEBFLOW_PUBLISH: "/api/integrations/webflow/publish",
  WEBFLOW_SITES: "/api/integrations/webflow/sites",
  WEBFLOW_COLLECTIONS: (siteId: string) =>
    `/api/integrations/webflow/${siteId}/collections`,
  WEBFLOW_CREATE_COLLECTION: "/api/integrations/webflow/create-collection",

  // WordPress endpoints
  WORDPRESS_AUTH: "/api/integrations/wordpress/auth",
  WORDPRESS_STATUS: "/api/integrations/wordpress/status",
  WORDPRESS_SITES: "/api/integrations/wordpress/sites",
  WORDPRESS_PUBLISH_POST: "/api/integrations/wordpress/publish-post",
} as const;

// Helper function to build full URL (kept for backwards compatibility, now just returns the endpoint)
export const buildApiUrl = (endpoint: string): string => {
  return endpoint;
};

// Common headers for API requests
export const getApiHeaders = (token?: string) => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return headers;
};
